import { Alert, AlertIcon } from '@sainsburys-tech/luna-react'
import { ErrorCircle } from '@sainsburys-tech/luna-icons'

type Props = {
  showError: false | string
  showSuccess: false | string
  showWarning?: false | string
  onClose: () => void
}

const FormAlerts = (props: Props) => {
  return (
    <>
      <Alert variant='error' open={props.showError !== false} onClose={props.onClose} squared>
        <AlertIcon>
          <ErrorCircle aria-label='Error' role='img' />
        </AlertIcon>
        {props.showError}
      </Alert>
      <Alert variant='success' open={props.showSuccess !== false} onClose={props.onClose} squared>
        {props.showSuccess}
      </Alert>
      {props.showWarning && (
      <Alert variant="warning" open={props.showWarning} onClose={props.onClose} squared>
        {props.showWarning}
      </Alert>
      )}
    </>
  )
}

export default FormAlerts